import { Injectable } from '@angular/core';
import { ConcessionarioPessoaController } from '../../controllers/mob/concessionario-pessoa.controller';
import { ConcessionarioPessoaDTO, ConcessionarioPessoaDTOList } from '../../model/dtos/mob/concessionario-pessoa.dto';
import { ApiService } from '../api-service.interface';
import { LoaderService } from '../loader.service';
import { ConcessionarioPessoaSearch } from './concessionario-pessoa.search';


@Injectable()
export class ConcessionarioPessoaService implements ApiService<ConcessionarioPessoaDTO>{

    constructor(
        private _concessionarioPessoaController: ConcessionarioPessoaController,
        private _loaderService: LoaderService
    ){}
    
    find(search?: any): Promise<ConcessionarioPessoaDTO[]> {
        throw new Error('Method not implemented.');
    }

    ativar(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO>{
        this._loaderService.show();
        return this._concessionarioPessoaController.ativar(entity).finally(() => this._loaderService.hide());
    }
    
    desativar(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO>{
        this._loaderService.show();
        return this._concessionarioPessoaController.desativar(entity).finally(() => this._loaderService.hide());
    }

    findConcessionarioPessoa(search?:ConcessionarioPessoaSearch):Promise<ConcessionarioPessoaDTOList>{
        this._loaderService.show();
        return this._concessionarioPessoaController.findConcessionarioPessoa(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    findHistorico(search?: ConcessionarioPessoaSearch) {
        this._loaderService.show();
        return this._concessionarioPessoaController.findHistorico(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    get(id: number): Promise<ConcessionarioPessoaDTO> {
        this._loaderService.show();
        return this._concessionarioPessoaController.get(id).finally(() => this._loaderService.hide());
    }

    save(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
        if (!entity.cdConcessionarioPessoa)
            return this.create(entity);
        return this.update(entity);
    }

    create(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
        this._loaderService.show();
        return this._concessionarioPessoaController.create(entity).finally(() => this._loaderService.hide());
    }

    update(entity: ConcessionarioPessoaDTO): Promise<ConcessionarioPessoaDTO> {
        this._loaderService.show();
        return this._concessionarioPessoaController.update(entity).finally(() => this._loaderService.hide());
    }

    async getConcessionarioPessoa(cdConcessionarioPessoa:number):Promise<any>{
        this._loaderService.show();
        return this._concessionarioPessoaController.get(cdConcessionarioPessoa).finally(() => this._loaderService.hide());
    }

    async findColetivoRural(concessaoPessoaSearch?:ConcessionarioPessoaSearch):Promise<ConcessionarioPessoaDTO[]>{
        try{return await this._concessionarioPessoaController.findColetivoRural(concessaoPessoaSearch && concessaoPessoaSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async findTaxi(concessaoPessoaSearch?:ConcessionarioPessoaSearch):Promise<ConcessionarioPessoaDTO[]>{
        try{return await this._concessionarioPessoaController.findTaxi(concessaoPessoaSearch && concessaoPessoaSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async findPermissionarioTaxi(concessaoPessoaSearch?:ConcessionarioPessoaSearch):Promise<ConcessionarioPessoaDTO[]>{
        try{return await this._concessionarioPessoaController.findPermissionarioTaxi(concessaoPessoaSearch && concessaoPessoaSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async findColetivoUrbano(concessaoPessoaSearch?:ConcessionarioPessoaSearch):Promise<ConcessionarioPessoaDTO[]>{
        try{return await this._concessionarioPessoaController.findColetivoUrbano(concessaoPessoaSearch && concessaoPessoaSearch.getFilters() || null);}
        catch(error){return [];}
    }
}